import styled from 'styled-components';

// Styled components
export const IntroPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 11px;
  margin: auto;
  width: 100%;
`;

export const IntroPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
  background-color: white;
  border: 1px solid rgb(229, 229, 229);
  border-radius: 10px;
  padding: 1rem;
  @media (max-width: 1024px) {
    padding: 1rem;
  }
  @media (max-width: 450px) {
    width: 90vw;
    margin: auto;
  }
`;
